import { render, staticRenderFns } from "./UpdateMGateBottomSheet.vue?vue&type=template&id=271043b1"
import script from "./UpdateMGateBottomSheet.vue?vue&type=script&lang=js"
export * from "./UpdateMGateBottomSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports